import cookie from "js-cookie";

import { USER_SEGMENT_COOKIE } from ".";

const segmentTypes = ["member", "nonmember", "lapsedmember"] as const;
type UserSegmentType = (typeof segmentTypes)[number];

export const setUserSegment = (segment: UserSegmentType): void => {
  cookie.remove(USER_SEGMENT_COOKIE); // this will remove any existing 'session' cookie
  cookie.set(USER_SEGMENT_COOKIE, segment, { expires: 30 });
};

export const getUserSegment = (): UserSegmentType => {
  const segment = cookie.get(USER_SEGMENT_COOKIE);
  const result = segmentTypes.find((item) => segment === item);
  if (result) return result;
  return "nonmember";
};

export const initUserSegment = (): void => {
  const segment = cookie.get(USER_SEGMENT_COOKIE);
  const result = segmentTypes.find((item) => segment === item);
  if (result) return;
  setUserSegment("nonmember");
};
